import React from 'react';
import MoneyRequestModal from './MoneyRequestModal';

// eslint-disable-next-line react/jsx-props-no-spreading
const IOURequestPage = (props) => <MoneyRequestModal {...props} />;
IOURequestPage.displayName = 'IOURequestPage';
export default IOURequestPage;
